import {
  GET_DASHBOARD_STAGES,
  GET_CHANGE_REQUESTS,
  POST_CHANGE_REQUEST,
  PUT_CHANGE_REQUEST,
  DELETE_CHANGE_REQUEST,
  MOVE_CHANGE_REQUEST_STAGE,
} from "../constants/actionTypes";

const defaultState = {
  dashboardStages: [],
  changeRequests: [],
};

export default (state = defaultState, action) => {
  try {
    switch (action.type) {
      case GET_DASHBOARD_STAGES:
        return { ...state, dashboardStages: [...action.payload] };
      case GET_CHANGE_REQUESTS:
        return { ...state, changeRequests: [...action.payload] };
      case POST_CHANGE_REQUEST:
        return { ...state, changeRequests: [...state.changeRequests, action.payload] };
      case PUT_CHANGE_REQUEST:
        return {
          ...state,
          changeRequests: state.changeRequests.map((item) =>
            item.id === action.payload.id ? action.payload : item
          ),
        };
      case DELETE_CHANGE_REQUEST:
        return {
          ...state,
          changeRequests: state.changeRequests.filter((item) => item.id !== action.payload),
        };
      case MOVE_CHANGE_REQUEST_STAGE:
        return {
          ...state,
          changeRequests: state.changeRequests.map((item) =>
            item.id === action.payload.id ? action.payload : item
          ),
        };
      default:
        return state;
    }
  } catch (error) {
    throw new Error(error);
  }
};
